import { isElementNode, isTag } from 'anodum';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';

const getCollapsedNodeAndOffset = () => {
  const selection = getAdvancedSelection();
  const { anchorNode, anchorOffset } = selection;

  if (isElementNode(anchorNode) && !isTag(anchorNode, 'br') && anchorNode.hasChildNodes()) {
    const childByIndex = anchorNode.childNodes[anchorOffset];
    return [childByIndex, 0];
  }
  return [anchorNode, anchorOffset];
};

export default getCollapsedNodeAndOffset;
